__turbopack_context__.v({
  "body": "WelcomePopup-module-scss-module__gB50DG__body",
  "footer": "WelcomePopup-module-scss-module__gB50DG__footer",
  "header": "WelcomePopup-module-scss-module__gB50DG__header",
  "image": "WelcomePopup-module-scss-module__gB50DG__image",
  "infoBtn": "WelcomePopup-module-scss-module__gB50DG__infoBtn",
  "modalWindow": "WelcomePopup-module-scss-module__gB50DG__modalWindow",
  "modalWindowBackdrop": "WelcomePopup-module-scss-module__gB50DG__modalWindowBackdrop",
  "opacityFadeIn": "WelcomePopup-module-scss-module__gB50DG__opacityFadeIn",
  "text": "WelcomePopup-module-scss-module__gB50DG__text",
});
